import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Join } from "@/components/Join";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main className="bg-[#0B1F3A] text-slate-50 overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Join />
      <Footer />
    </main>
  );
}
